(function(w, d) {
    if (typeof NodeList.prototype.forEach !== "function") { NodeList.prototype.forEach = Array.prototype.forEach; }
    d.addEventListener("DOMContentLoaded", function() {
        w.searchGrid_config.forEach(function(o) {
             // Fotomoto js needed for buy now functionality
             function fotomotoBuy(highRes, preview) {
                var checkUrl = 'https://widget.fotomoto.com/stores/photo_checkin',
                    imgs = [];
                imgs.push({
                    img: preview,
                    original_image_url: highRes,
                    collection: ''
                });
                $.post(checkUrl, {store_key: o.foto_id, page_url: o.page_url, imgs: imgs}, function(data) {
                    console.log(data);
                }, 'json');
                FOTOMOTO.API.checkinImages(imgs, function(images){
                    if (images[0].available) {
                        FOTOMOTO.API.showWindow(FOTOMOTO.API.BUY, preview);
                    }
                    else {
                        alert("This image is currently not available for sale.");
                    }
                })
            }
            function FOTOMOTOPANEL_beforeShow() {
                $(document).off('focusin.modal');
            }
            
             // Observers for asset setup and reflow
             function setObserver() {
                var targetNode = d.getElementById('dycol-' + o.asset_UUID),
                    config = { childList: true },
                    callback = function(mutationsList, observer) {
                    for(var { addedNodes }  of mutationsList) {
                        for (var node of addedNodes) {
                            if (node && node.innerHTML.indexOf("card-container") != -1){
                                setTimeout(function(){
                                    collectAssets();
                                    observer.disconnect();
                                }, 750);
                            }
                        }
                    }
                }
                
                var observer = new MutationObserver(callback);
                if (observer){
                    observer.observe(targetNode, config);
                }
                
                var scrollObserver = new IntersectionObserver(
                    function (entries) {
                        if (entries[0].intersectionRatio <= 0) {
                            return;
                        } else {
                            w.addEventListener("scroll", containReflow);
                        }
                    }
                );
                
                scrollObserver.observe(
                    d.querySelector('.tnt-dynamic-collection')
                );
            }

            // Collect assets
            function collectAssets() {
                var allItems = d.querySelectorAll('.page .content .asset');
                for (var x = 0; x < allItems.length; x++) {
                    var item = allItems[x],
                        close = d.querySelector('.modal.search-collection .close'),
                        headlineHref = item.querySelector('.inline-grid .tnt-headline a'),
                        summaryHref = item.querySelector('.inline-grid .tnt-headline a, .inline-summary .tnt-headline a');
                        
                    if (item.querySelector('article').classList.contains('has-image')){
                        item.classList.add('has-image');
                    }    
                    if (item.querySelector('.image .tnt-asset-link') != null){
                        item.querySelector('.image .tnt-asset-link').setAttribute('onclick', 'return false'); 
                    }
                    if (item.classList.contains('has-image')){
                        if (summaryHref != null) {
                            summaryHref.setAttribute('onclick', 'return false');
                        }
                        if (headlineHref != null){
                            headlineHref.setAttribute('onclick', 'return false'); 
                        }
                    }
                    item.addEventListener("click", modalOpen, false);
                    close.addEventListener("click", modalClose, false);
                }
                if (o.subtype == 'dynamic') {
                    containReflow();
                }
            }
                    
            // Close Modal
            function modalClose() {
                var modal = d.querySelector('.modal.search-collection');
                modal.classList.remove('in');
                modal.style.display = '';
                modal.querySelector('.actions.pull-right').innerHTML = '';
                d.querySelector('.asset.active').classList.remove("active");
                d.querySelector('.tnt-dynamic-collection').classList.remove('hidden-print');
                d.querySelector('.card-image').classList.remove('hidden-print');
            };
            
            // Find next sibling
            function getNextSibling(elem, selector) {
                var sibling = elem.nextSibling;
                if (!selector) return sibling;
                while (sibling) {
                    if (sibling.matches(selector)) return sibling;
                    sibling = sibling.nextSibling
                }
            }
            
            // Find previous sibling
            function getPrevSibling(elem, selector) {
                var sibling = elem.previousSibling;
                if (!selector) return sibling;
                while (sibling) {
                    if (sibling.matches(selector)) return sibling;
                    sibling = sibling.previousSibling
                }
            }
                    
            // Page count & static paging
            function pageCount(e) {
                var page = parseInt(d.querySelector('.paging-count .count').innerHTML),
                    targetArrowClass = e.target.closest('.photo-carousel-control-static').classList,
                    sDirection,
                    sOppDirection;
                if (targetArrowClass.contains('right')){
                    sDirection = 'right';
                    sOppDirection = 'left';
                } else {
                    sDirection = 'left';
                    sOppDirection = 'right';
                }
                if (d.querySelector('.photo-carousel-control-static.' + sDirection).classList.contains('disabled')) {
                    return false;
                } else {
                    var allItems = d.querySelectorAll('.content .asset'),
                        count = parseInt(d.querySelector('.paging-count .count').innerHTML);
                    if (sDirection == 'right'){
                        page++;
                        count++;
                    } else if (sDirection == 'left'){
                        if (count <= 1){
                            count == 1;
                        } else {
                            page--;
                            count--;
                        }
                    }
                    d.querySelector('.paging-count .count').innerHTML = count;
                    for (var x = 0; x < allItems.length; x++) {
                        var item = allItems[x];
                        if (item.dataset.page == page) {
                            d.querySelector('.photo-carousel-control-static.right').classList.remove('disabled');
                            item.classList.remove('hide');
                            if (item.dataset.page == 1) {
                                d.querySelector('.photo-carousel-control-static.left').classList.add('disabled');
                            } else if (item.classList.contains('last')) {
                                d.querySelector('.photo-carousel-control-static.right').classList.add('disabled');
                                d.querySelector('.photo-carousel-control-static.left').classList.remove('disabled');
                            } else {
                                d.querySelector('.photo-carousel-control-static.left').classList.remove('disabled');
                            }
                        } else {
                            item.classList.add('hide');
                        }
                    }
                }
            }
            
            // Open Modal 
            function modalOpen(e) {
                var modal = d.querySelector('.modal.search-collection'),
                    close = d.querySelector('.modal.search-collection .close'),
                    parent = e.target.closest('.asset'),
                    img = parent.querySelector('img'),
                    image = modal.querySelector('img'),
                    href = parent.querySelector('.inline-grid').getAttribute('data-url'),
                    title = img.getAttribute('alt'), 
                    imageSrc = parent.querySelector('.inline-grid').getAttribute('data-image');
                __tnt.trackEvent( {'url': href, 'title': title + ' - Search grid collection - dynamic'} )    
                image.setAttribute('src', '');
                image.setAttribute('src', imageSrc);
                if (parent.querySelector('.actions.pull-right')){
                    modal.querySelector('.actions.pull-right').classList.remove('hide')
                    var html = parent.querySelector('.actions.pull-right');
                    modal.querySelector('.actions.pull-right').appendChild(html);
                } else {
                    modal.querySelector('.actions.pull-right').classList.add('hide')
                }
                parent.classList.add('active');
                close.addEventListener("click", modalClose, false);
                modal.style.display = 'block';
                modal.classList.add('in');
                d.querySelector('.tnt-dynamic-collection').classList.add('hidden-print');
                d.querySelector('.card-image').classList.add('hidden-print');
                if (parent.querySelector('.tnt-summary') != null && o.hide_details != true) {
                    var caption = parent.querySelector('.tnt-summary').innerHTML,
                        captionModal = modal.querySelector('.caption-text p');
                    captionModal.innerHTML = caption;
                } else {
                    modal.querySelector('.caption-text p').innerHTML = '';
                }
            }
                    
            // Modal navigation
            function modalNavigation(e) {
                var arrow = e.target.closest('.photo-carousel-control');
                if(arrow.classList.contains('right')){
                    var active = d.querySelector('.asset.active');
                    if (!getNextSibling(active)){
                        var prevPage =  d.querySelector('.asset.active').parentElement.parentElement.nextElementSibling;
                        if (prevPage == null){
                            var next = d.querySelector('.page .content .asset.has-image')
                        } else {
                            var next = prevPage.querySelector('.content').firstChild;
                        }
                    } else if (getNextSibling(active, '.has-image') == undefined){
                        next = d.querySelector('.tnt-dynamic-collection > .page > .content > .asset.has-image');
                    } else {
                        next = getNextSibling(active, '.has-image');
                    }
                } else {
                    var next = d.querySelector('.asset.active').previousElementSibling;
                    if (!next){
                        var prevPage =  d.querySelector('.asset.active').parentElement.parentElement.previousElementSibling;
                        var next = prevPage.querySelector('.content').lastChild;
                    } else if (!next.classList.contains('has-image')){    
                        var next = d.querySelector('.asset.active').previousElementSibling.previousElementSibling;
                            if (!next.classList.contains('has-image') || next.classList.contains('tnt-ads-container')){
                                var next = getPrevSibling(next, '.has-image'),
                                title = next.querySelector('img').getAttribute('alt');
                            }
                    }
                    else if (next.classList.contains('tnt-ads-container')){
                        var next =  d.querySelector('.asset.active').previousElementSibling.previousElementSibling;
                        var title = next.querySelector('img').getAttribute('alt');
                        if (!next.classList.contains('has-image')){
                            var next =  d.querySelector('.asset.active').previousElementSibling.previousElementSibling.previousElementSibling;
                                title = next.querySelector('img').getAttribute('alt');
                        }    
                    }
                }
                var modal = d.querySelector('.modal.search-collection'),
                    image = modal.querySelector('img'),
                    href = next.querySelector('.inline-grid').getAttribute('data-url'),
                    title = next.querySelector('img').getAttribute('alt'),
                    current = d.querySelector('.asset.active'),
                    parent = next.querySelector('.inline-grid');
                __tnt.trackEvent( {'url': href, 'title': title + ' - Search grid collection - dynamic'} )       
                image.setAttribute('src', '');
                modal.querySelector('.actions.pull-right').innerHTML = '';
                current.classList.remove("active");
                next.classList.add('active');
                if (next.querySelector('.actions.pull-right')){
                    modal.querySelector('.actions.pull-right').classList.remove('hide')
                    var html = next.querySelector('.actions.pull-right');
                    modal.querySelector('.actions.pull-right').appendChild(html);
                }   
                if (next.querySelector('.tnt-summary') != null){
                    var caption = next.querySelector('.tnt-summary').innerHTML,
                        captionModal = modal.querySelector('.caption-text p')
                    captionModal.innerHTML = caption;
                } else {
                    modal.querySelector('.caption-text p').innerHTML = '';
                }
                setTimeout(function() {
                    var img = next.querySelector('img'),
                        imageSrc = parent.getAttribute('data-image');
                    image.setAttribute('src', imageSrc);
                }, 250) 
            }
                    
            // Caption toggle
            var toggle = d.querySelector('.photo-carousel-caption-toggle');
            if (toggle){
                toggle.onclick = function(){
                    var sIcon = toggle.querySelector('.tnt-svg').getAttribute('data-icon');
                    if(sIcon == 'minus-circle'){
                        toggle.querySelector('.tnt-svg').setAttribute('data-icon','plus-circle');
                    } else {
                        toggle.querySelector('.tnt-svg').setAttribute('data-icon','minus-circle');
                    }
                    d.querySelector('.caption-inner.collapse').classList.toggle('in');
                }
            }
            
            // Dynamic CSS to eliminate reflow
            function containReflow(){
                function resizeGridItem(item){
                    var grid = d.querySelector('.content');
                    if (grid === null){ 
                        return;
                    } else {
                        var rowHeight = parseInt(w.getComputedStyle(grid).getPropertyValue('grid-auto-rows')),
                        rowGap = parseInt(w.getComputedStyle(grid).getPropertyValue('grid-row-gap')),
                        rowSpan = Math.floor((item.querySelector('.card-container').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
                        rowSpan = (rowSpan + 1);
                        item.style.gridRowEnd = "span "+rowSpan;
                    }
                }
                function resizeAllGridItems(){
                    var allItems = d.getElementsByClassName("asset");
                    for( x=0; x<allItems.length; x++ ){
                        resizeGridItem(allItems[x]);
                    }
                }
                function resizeInstance(instance){
                    var item = instance.elements[0];
                    resizeGridItem(item);
                }
                resizeAllGridItems();
            }
                    
            // Add static nav listeners
            if (o.subtype != 'dynamic') {
                collectAssets();
                setTimeout(function() {
                    var nextArrow = d.querySelector('.photo-carousel-control-static.right');
                    if (nextArrow){
                        nextArrow.addEventListener("click", pageCount);
                        d.querySelector('.photo-carousel-control-static.left').addEventListener("click", pageCount);
                    }
                }, 250);
            } else {
                w.addEventListener("resize", containReflow);
                d.querySelector('.tnt-load-more').addEventListener("click", function () {
                    setObserver();
                })   
            }
            setObserver();
            d.querySelector('.photo-carousel-control.right').addEventListener("click", modalNavigation);
            d.querySelector('.photo-carousel-control.left').addEventListener("click", modalNavigation);
        })
    }) 
})(window, document)